// extracted by mini-css-extract-plugin
module.exports = {"box":"box--6rmpz","title":"title--PlpAj"};